var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.575,
    height: 30,
    viewBox: "0 0 27.575 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M2118.4-1905.807a9.619,9.619,0,0,1-1.047,4.34,7.743,7.743,0,0,1-1.144,1.744c-.146.168-.147.262.021.433q4.492,4.568,8.966,9.155a2.46,2.46,0,0,1,.329,2.864,2.434,2.434,0,0,1-2.643,1.136,2.471,2.471,0,0,1-1.522-.989q-3.684-5.054-7.382-10.1c-.162-.222-.275-.263-.516-.116a9.57,9.57,0,0,1-5.03,1.4,9.8,9.8,0,0,1-6.635-2.43,10.044,10.044,0,0,1-3.4-6.074,10.139,10.139,0,0,1,4.569-10.075,10,10,0,0,1,5.558-1.558,10.063,10.063,0,0,1,9.808,8.764A14.2,14.2,0,0,1,2118.4-1905.807Zm-10.06-8.069a7.811,7.811,0,0,0-7.884,7.869,7.824,7.824,0,0,0,7.877,7.881,7.856,7.856,0,0,0,7.9-7.892A7.846,7.846,0,0,0,2108.339-1913.877Z",
    transform: "translate(-2098.263 1916.075)",
    fill: "#215c75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M2161.179-1799.53c1.773,0,3.546.008,5.32-.007.311,0,.4.1.39.392q-.02.949,0,1.9c.005.276-.09.373-.375.373q-5.338,0-10.676.026c-.34,0-.476-.116-.463-.467.021-.594.019-1.191,0-1.785-.01-.335.121-.436.446-.434,1.786.011,3.572.005,5.357.005Z",
    transform: "translate(-2151.029 1808.405)",
    fill: "#215c75"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.aceb91d90cf7f51bc03da220614e3a78.svg";
export { ForwardRef as ReactComponent };